import { render } from "./VsudPaginationItem.vue?vue&type=template&id=263f790a"
import script from "./VsudPaginationItem.vue?vue&type=script&lang=js"
export * from "./VsudPaginationItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__